import script from "./ExamList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamList.vue?vue&type=script&setup=true&lang=js"

import "./ExamList.vue?vue&type=style&index=0&id=80902ccc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80902ccc"]])

export default __exports__